import { EditIcon, DeleteIcon } from '@chakra-ui/icons';

export const columnsDataBrands = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Marca",
    accessor: "name",
  },
  {
    Header: '',
    accessor: 'actions',
    actions: [
      {
        label: 'Editar',
        icon: <EditIcon />,
        colorScheme: 'blue',
        type: 'edit'
      },
      {
        label: 'Eliminar',
        icon: <DeleteIcon />,
        colorScheme: 'red',
        type: 'delete'
      },
    ]
  }
  
];
